
import { Component, Vue, Prop } from "vue-property-decorator";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";
import LastPostCard from "./lastPostCard.vue";

@Component({
  components: {
    ScrollableBanner,
    LastPostCard
  },
})
export default class LastPostsBanner extends Vue {
  @Prop({ required: false, default: true }) private showTitle!: boolean;
  @Prop() title!: string;
  posts: any[] = [];
  windowWidth: number = window.innerWidth;

  async mounted() {
    const url = `${Settings.HostName}/api/cztextblocks/list-with-users?count=3`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting last posts");
      return;
    }
    this.posts = data;
  }
}
